import React from 'react';

import useCartState from '../../../hooks/useCartState';
import OrderSummaryContainer from './order-summary-container';
import CheckoutContainer from './checkout-container';
import MobileCheckout from './checkout-container/mobile-checkout';
import PaymentMethods from './payment-methods';
import OrderSummaryTimer from './order-summary-timer';
import CallCenter from './call-center';
import LinkGroup from './link-group';

import './order-summary.less';

export default ({ csrActions }) => {
    const { cartViewIsLoading, emptyCart, cartInfo } = useCartState();
    const { disableCartAction } = cartInfo || {};
    const disableActionClass = disableCartAction ? 'disable-action' : '';
    return (
        <>
            <div className={`order-summary ${cartViewIsLoading || emptyCart ? 'loading' : ''}`}>
                <OrderSummaryTimer />
                <div className={disableActionClass}>
                    <OrderSummaryContainer />
                </div>
                <CheckoutContainer csrActions={csrActions} className={disableActionClass} />
                <LinkGroup />
                <PaymentMethods />
                <CallCenter />
            </div>
            <MobileCheckout />
        </>
    );
};
